import React, { useMemo } from 'react';
import classnames from 'classnames';

import styles from '../AgeVerificationOverlay/AgeVerificationOverlay.module.css';
import { UserContext } from '../../context';


function SfwImage({ overlayedImage, sfwImage, nsfwImage, alt, ...rest }) {
  const user = React.useContext(UserContext);
  // Real (NSFW) content is only shown once the user has both logged in and
  // affirmed/verified their age (via Yoti or the age verification overlay).
  // Everyone else (guests and unverified members) gets the SFW treatment.
  const ageAffirmed = sessionStorage.getItem('adult_content_ack') === 'true';
  const showNsfwContent = user?.authenticated === true && ((ageAffirmed && !user?.sfw) || user?.sfw);
  const sfwImageExists = sfwImage && !sfwImage?.includes('null');
  const image = useMemo(() => {
    if (!sfwImageExists) {
      return nsfwImage;
    }

    return sfwImage;
  }, [sfwImageExists, sfwImage, nsfwImage]);

  if (!showNsfwContent) {
    return (
      <React.Fragment>
        {overlayedImage && !sfwImageExists && (
          <img
            alt="Members Only"
            className={classnames(
              styles.membersOnlyOverlay,
              'unblurred nn-logo'
            )}
            src={overlayedImage}
          />
        )}
        <img
          {...rest}
          alt={alt}
          className={classnames('unblurred nn-logo', rest.className)}
          src={image}
          style={{
            ...(!sfwImageExists && { filter: 'blur(10px)' }),
            ...rest.style,
          }}
        />
      </React.Fragment>
    );
  }

  return <img alt={alt} src={nsfwImage} {...rest} />;
}

export default SfwImage;
